import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type UserRole = 'candidate' | 'employer' | 'both' | null;

export interface AuthProfile {
  id: string;
  email: string;
  name: string;
  role: UserRole;
}

interface AuthState {
  profile: AuthProfile | null;
  entitlements: string[];
  roleSelection: UserRole;
  isAuthenticated: boolean;
  setProfile: (profile: AuthProfile | null) => void;
  setEntitlements: (entitlements: string[]) => void;
  setRoleSelection: (role: UserRole) => void;
  login: (profile: AuthProfile, entitlements: string[]) => void;
  logout: () => void;
  hasEntitlement: (entitlement: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      profile: null,
      entitlements: [],
      roleSelection: null,
      isAuthenticated: false,

      setProfile: (profile) => set({ profile, isAuthenticated: !!profile }),

      setEntitlements: (entitlements) => set({ entitlements }),

      setRoleSelection: (roleSelection) => set({ roleSelection }),

      login: (profile, entitlements) =>
        set({
          profile,
          entitlements,
          isAuthenticated: true,
        }),

      logout: () =>
        set({
          profile: null,
          entitlements: [],
          roleSelection: null,
          isAuthenticated: false,
        }),

      hasEntitlement: (entitlement: string) => {
        return get().entitlements.includes(entitlement);
      },
    }),
    {
      name: 'bp_auth',
      partialize: (state) => ({
        profile: state.profile,
        entitlements: state.entitlements,
        roleSelection: state.roleSelection,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
